import { render } from "./StreamsManageAlerts.vue?vue&type=template&id=ae547dca"
import script from "./StreamsManageAlerts.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsManageAlerts.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/StreamsDash/StreamsManageAlerts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ae547dca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ae547dca', __exports__)) {
    api.reload('ae547dca', __exports__)
  }
  
  module.hot.accept("./StreamsManageAlerts.vue?vue&type=template&id=ae547dca", () => {
    api.rerender('ae547dca', render)
  })

}


export default __exports__